import Grid from '@material-ui/core/Grid';
import useStyles from './LayoutWrapper.styles';
import { useUser } from 'utils/hooks';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { EClientType } from 'utils/enums/BackofficeClientType/ClientTypes';

interface LayoutWrapperProps {
    children: React.ReactNode;
    hide?: boolean;
    wrapper?: boolean;
    style?: object;
    customClass?: any;
}

export function LayoutWrapper({ children, hide, wrapper, style, customClass, ...props }: LayoutWrapperProps) {
    const { user } = useUser({});
    const router = useRouter();
    const EX5242 = user?.EX5242; //FF epic offline
    const canCreateVendors = user?.features?.can_create_vendor;
    const classes = useStyles();

    const [isNewDesign, setIsNewDesign] = useState(false);

    useEffect(() => {
        if (
            router?.pathname === `/pos/[clientId]/[posId]` ||
            (EX5242 && router?.pathname === `/pos/[clientId]/[posId]/addOfflineDrugstore/[[...offlineDrugstoreId]]`) ||
            (canCreateVendors && router?.pathname === `/clients/drugmanufacturers`) ||
            (canCreateVendors && router?.pathname === `/clients/types`) ||
            (canCreateVendors &&
                router?.pathname === `/clients/[clientId]/[typeId]` &&
                +router.query.typeId === EClientType.Drugstore)
        ) {
            setIsNewDesign(true);
        } else {
            setIsNewDesign(false);
        }
    }, [router?.pathname]);

    return (
        <Grid
            style={style}
            className={[
                hide && !wrapper
                    ? classes.container
                    : wrapper
                    ? classes.wrapper
                    : isNewDesign
                    ? classes.rootV2
                    : classes.root,
                customClass,
            ].join(' ')}
            {...props}
        >
            {children}
        </Grid>
    );
}

export default LayoutWrapper;
